/**
 * Native Media.
 *
 * @description Class that mimics the HTML5 MediaElement's standard methods.
 * All the methods are availabe for the different types of media; the exceptions
 * are the getter/setter of a source, load it and determine if media can be played,
 * since each one of the media types handle those in a different way.
 *
 * @abstract
 * @class Native
 */

abstract class Native {
  videoEl!: HTMLVideoElement
  media = null;
  promise:Promise<boolean>

  constructor(videoEl: HTMLVideoElement, media: any) {
    this.videoEl = videoEl;
    this.media = media;
    this.promise = new Promise((resolve,reject) => {
      resolve(true);
    });
  }

  play = () => {
    return this.videoEl.play();
  }

  pause = () => {
    this.videoEl.pause();
  }

  /*Setter Getter */

  set volume(val) {
    this.videoEl.volume = val;
  }
  get volume() {
    return this.videoEl.volume;
  }

  set muted(val) {
    this.videoEl.muted = val;
  }

  get muted() {
    return this.videoEl.muted;
  }

  set playbackRate(val) {
    this.videoEl.playbackRate = val;
  }

  get playbackRate() {
    return this.videoEl.playbackRate;
  }

  set defaultPlaybackRate(val) {
    this.videoEl.defaultPlaybackRate = val;
  }

  get defaultPlaybackRate() {
    return this.videoEl.defaultPlaybackRate;
  }

  set currentTime(val) {
    this.videoEl.currentTime = val;
  }

  get currentTime() {
    return this.videoEl.currentTime;
  }

  get duration() {
    return this.videoEl.duration;
  }

  get paused() {
    return this.videoEl.paused
  }

  get ended() {
    return this.videoEl.ended;
  }

}
export default Native;
